import { ConfirmationLineTable } from "./ConfirmationLineTable";
import type { ConfirmationCategoryTableProps, ConfirmationTableColumn } from "./tableTypes";
import { col, text, subtotal } from "./tableColumns";
import { confirmationGroupKey, confirmationDateKey } from "../../../service/confirmationEditorView";
import { confirmationTableBusScope } from "../../../service/confirmationTablePresentation";
import type { FulfillmentOrderLine } from "../../../types";

/** 独立维护用车范围、车型和车辆计费的表格展示。 */
export function ConfirmationBusTable({ common, table }: ConfirmationCategoryTableProps) {
  const { item, date, quantity, count, price, amount, provider, tail } = common;
  const groupKey = (line: FulfillmentOrderLine) => confirmationGroupKey(line, "bus");
  const groupedDate = { ...date, merge: (line: FulfillmentOrderLine) => JSON.stringify([groupKey(line), confirmationDateKey(line)]) };
  const columns: ConfirmationTableColumn[] = [
    { ...item, label: "用车区域 / 范围", width: 172, render: (line) => <>{common.itemTitle(line, line.itemNameSnapshot)}<small>{confirmationTableBusScope(line)}</small></> },
    groupedDate,
    col("vehicle", "车型", 104, (line) => <><strong>{line.resourceSelection?.kind === "bus" ? line.resourceSelection.vehicleSpecName : text(line.skuNameSnapshot || line.itemSpecSnapshot)}</strong><small className="confirmation-item-detail">{line.resourceSelection?.kind === "bus" && <span>车型表</span>}<span className="confirmation-line-number">#{line.lineNo}</span></small></>),
    quantity("车辆数"), count(), price, amount, subtotal("用车小计 / 差异", groupKey), provider, ...tail,
  ];
  return <ConfirmationLineTable {...table} columns={columns} variant="bus" />;
}
